import { isString } from 'lodash';

import { DELAY_STATUS, MODE_AIR, MODE_INTERMODAL } from '@/lib/constants';
import { ShipmentModel, ShipmentTrackingDataModel } from '@/lib/models/shipment/types';
import { DelayStatus } from '@/types';

export const parseShipmentTrackingData = (
  trackingData?: string | ShipmentTrackingDataModel,
): ShipmentTrackingDataModel | null => {
  if (trackingData) {
    return isString(trackingData) ? JSON.parse(trackingData) : trackingData;
  }

  return null;
};

export const getShipmentEtaStatus = (delay: ShipmentModel['delay'], modeType?: ShipmentModel['type']): DelayStatus => {
  if (delay && modeType) {
    // Flights are more sensitive to delays
    if (modeType === MODE_AIR) {
      if (delay > 0) return DELAY_STATUS.DELAYED;
      if (delay < 0) return DELAY_STATUS.AHEAD;
    }
    if (modeType === MODE_INTERMODAL) {
      if (delay >= 1200) return DELAY_STATUS.DELAYED; // more than 20 hours late
      if (delay <= -1200) return DELAY_STATUS.AHEAD; // more than 20 hours early
    }
  }
  return DELAY_STATUS.ONTIME;
};

export const isContainerIsoReefer = (containerISO?: string) => {
  if (!containerISO || containerISO.length !== 4) {
    return false;
  }
  // The ISO type code for them is XXRX where “R” stands for “Reefer”.
  return containerISO[2].toUpperCase() === 'R';
};
